import React from 'react';

export default function Fetching() {
  return (
    <div
      className="m-4 relative block rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      <div role="status">
        <span className="sr-only">Nessun dato</span>
      </div>
      <span className="mt-2 block text-sm font-semibold text-gray-900">Nessun dato trovato</span>
    </div>
  )
}